import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      // Offset for the fixed app bar (64px) + product tabs bar (64px) plus breathing room.
      return { el: to.hash, top: 144, behavior: 'smooth' };
    }
    return { top: 0 };
  },
  // routes: (_routes) => [
  //   // {
  //   //   name: 'wiresock-vpn-client',
  //   //   path: '/wiresock-vpn-client',
  //   //   alias: '/',
  //   // },
  //   // {
  //   //   name: 'wiresock-vpn-client--download',
  //   //   path: '/wiresock-vpn-client/download',
  //   //   // alias: '/wiresock-vpn-client/download-wiresock-vpn-client',
  //   // },
  // ],
}
